import Cookies from 'js-cookie'
import {Navigate} from "react-router-dom";

export const getAccessToken = () => Cookies.get('access_token');
export const isAuthenticated = () => !!getAccessToken();

export const authenticate = async (usuario) => {
    try {
        const response = await fetch('/api/Contas/Autenticar', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(usuario)
        });

        const tokens = await response.json();
        const expires = (60 * 60) * 1000
        const inOneHour = new Date(new Date().getTime() + expires)

        Cookies.set('access_token', tokens.access_token, {expires: inOneHour})

        return true
    } catch (error) {
        redirectToLogin();
        return false
    }
};

const redirectToLogin = () => {
    window.location.href = '/login';
};

export const PrivateRoute = ({children}) => {
    return isAuthenticated() ? children : <Navigate to="/login"/>;
};